import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "col-auto" }
const _hoisted_2 = { class: "col text-left text-weight-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_bar = _resolveComponent("q-bar")!
  const _component_Line = _resolveComponent("Line")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($props.usehistory)
      ? (_openBlock(), _createBlock(_component_q_btn, {
          key: 0,
          align: "right",
          flat: "",
          round: "",
          icon: "addchart",
          size: "sm",
          onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.history = true))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_tooltip, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString($setup.t('history.historytrend')), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_q_dialog, {
      modelValue: $setup.history,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.history) = $event)),
      maximized: $setup.maximizedToggle,
      onBeforeShow: $options.onBeforeShow,
      onBeforeHide: $options.onBeforeHide,
      "transition-show": "slide-up",
      "transition-hide": "slide-down"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_bar, {
              dark: "",
              class: "bg-primary text-white"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createTextVNode(_toDisplayString($props.description) + " ", 1),
                  _createVNode(_component_q_btn, {
                    dense: "",
                    flat: "",
                    "icon-right": "archive",
                    "no-caps": "",
                    onClick: $options.exportTable
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_tooltip, { class: "bg-white text-primary" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString($setup.t('tags.exporttocsv')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["onClick"]),
                  _createVNode(_component_q_btn, {
                    dense: "",
                    flat: "",
                    "icon-right": "picture_as_pdf",
                    "no-caps": "",
                    onClick: $options.exportTablePDF
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_tooltip, { class: "bg-white text-primary" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString($setup.t('events.exporttopdf')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _createVNode(_component_q_select, {
                  dark: "",
                  "bg-color": "transparent",
                  style: { width: '200px', fontSize: '12px' },
                  color: "primary",
                  "onUpdate:modelValue": [
                    $options.updateTimeSelection,
                    _cache[1] || (_cache[1] = ($event: any) => (($setup.model) = $event))
                  ],
                  "transition-show": "flip-up",
                  "transition-hide": "flip-down",
                  dense: "",
                  flat: "",
                  filled: "",
                  modelValue: $setup.model,
                  options: $setup.options,
                  label: $setup.t('events.timeperiod')
                }, {
                  prepend: _withCtx(() => [
                    _createVNode(_component_q_icon, {
                      color: "white",
                      name: "history"
                    })
                  ]),
                  _: 1
                }, 8, ["onUpdate:modelValue", "modelValue", "options", "label"]),
                _createVNode(_component_q_space),
                _createVNode(_component_q_btn, {
                  dense: "",
                  flat: "",
                  icon: "minimize",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.maximizedToggle = false)),
                  disable: !$setup.maximizedToggle
                }, {
                  default: _withCtx(() => [
                    ($setup.maximizedToggle)
                      ? (_openBlock(), _createBlock(_component_q_tooltip, {
                          key: 0,
                          class: "bg-white text-primary"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString($setup.t('dialog.minimize')), 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["disable"]),
                _createVNode(_component_q_btn, {
                  dense: "",
                  flat: "",
                  icon: "crop_square",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.maximizedToggle = true)),
                  disable: $setup.maximizedToggle
                }, {
                  default: _withCtx(() => [
                    (!$setup.maximizedToggle)
                      ? (_openBlock(), _createBlock(_component_q_tooltip, {
                          key: 0,
                          class: "bg-white text-primary"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString($setup.t('dialog.maximize')), 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["disable"]),
                _withDirectives(_createVNode(_component_q_btn, {
                  dense: "",
                  flat: "",
                  icon: "close"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_tooltip, { class: "bg-white text-primary" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString($setup.t('dialog.close')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 512), [
                  [_directive_close_popup]
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_Line, {
              "chart-options": $options.chartOptions,
              "chart-data": $options.chartData,
              "chart-id": $props.chartId,
              "dataset-id-key": $props.datasetIdKey,
              plugins: $props.plugins,
              "css-classes": $props.cssClasses,
              styles: $props.styles,
              width: $props.width,
              height: $props.height,
              tagname: $props.tagname
            }, null, 8, ["chart-options", "chart-data", "chart-id", "dataset-id-key", "plugins", "css-classes", "styles", "width", "height", "tagname"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue", "maximized", "onBeforeShow", "onBeforeHide"])
  ]))
}